"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextareaMixin = void 0;
var _styledComponents = require("styled-components");
var _InputMixin = require("./InputMixin");
/** @class TextareaMixin */
/** @method */
var TextareaMixin = function TextareaMixin(props) {
  var resize = props.resize;
  return (0, _styledComponents.css)(["", " resize:", ";height:auto;vertical-align:top;"], (0, _InputMixin.InputMixin)(props), resize);
};
exports.TextareaMixin = TextareaMixin;